import ReferenceType from "$types/ReferenceType";

const { ORDER, PRODUCT } = ReferenceType;

// eslint-disable-next-line import/prefer-default-export
export const REFERENCE_TYPE_LABELS = {
  [ORDER]: "à la réception",
  [PRODUCT]: "à l'article",
};
